import type { Addon as PopsAddon } from '@/types/pops'
import type { CMSAddonsOptionGroup } from '@/types/sanity'

import { Addon } from './addon'

export class AddonGroup {
  config: CMSAddonsOptionGroup
  addons: Addon[]

  constructor(addonGroupConfig: CMSAddonsOptionGroup, popsAddons: PopsAddon[]) {
    this.config = addonGroupConfig
    this.addons = addonGroupConfig.options
      .map((option) => {
        const popsAddon = popsAddons.find(
          (popsAddon) =>
            popsAddon.shopify_variant_id.toString() ===
            option.variant.id.toString(),
        )
        if (!popsAddon) return null

        return new Addon(popsAddon, option)
      })
      .filter((addon) => addon) as Addon[]
  }
}
